var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnghamilabaudioad({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 131.266,
    height: 86.643,
    viewBox: "0 0 131.266 86.643",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_866",
    x: 22.313,
    y: 0,
    width: 86.643,
    height: 86.643,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Audio_Ad",
    "data-name": "Audio Ad",
    transform: "translate(-549.785 -969.776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18674",
    "data-name": "Group 18674",
    transform: "translate(549.785 976.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31292",
    "data-name": "Path 31292",
    d: "M511.105,966.184A1.085,1.085,0,0,1,510,965.12v-5.513a1.106,1.106,0,0,1,2.211,0v5.513A1.085,1.085,0,0,1,511.105,966.184Zm8.289,3.175V955.367a1.106,1.106,0,0,0-2.211,0v13.992a1.106,1.106,0,0,0,2.211,0Zm7.184-1.369V956.736a1.106,1.106,0,0,0-2.211,0V967.99a1.106,1.106,0,0,0,2.211,0Zm7.184,6.312V950.424a1.106,1.106,0,0,0-2.211,0V974.3a1.106,1.106,0,0,0,2.211,0Zm7.184,2.433V947.991a1.106,1.106,0,0,0-2.211,0v28.743a1.106,1.106,0,0,0,2.211,0Zm7.184,10.418V937.574a1.106,1.106,0,0,0-2.21,0v49.578a1.106,1.106,0,0,0,2.21,0Z",
    transform: "translate(-508.876 -925.539)",
    fill: "#945cff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31292_-_Outline",
    "data-name": "Path 31292 - Outline",
    d: "M547.148,989.464a2.259,2.259,0,0,1-2.229-2.283V937.792a2.229,2.229,0,1,1,4.457,0v49.388A2.259,2.259,0,0,1,547.148,989.464Zm-7.184-10.378a2.259,2.259,0,0,1-2.229-2.283V948.169a2.229,2.229,0,1,1,4.458,0V976.8A2.259,2.259,0,0,1,539.964,979.086Zm-7.184-2.423a2.259,2.259,0,0,1-2.229-2.283V950.594a2.229,2.229,0,1,1,4.458,0v23.786A2.259,2.259,0,0,1,532.78,976.662Zm-14.368-4.923a2.259,2.259,0,0,1-2.229-2.283V955.517a2.229,2.229,0,1,1,4.457,0v13.938A2.259,2.259,0,0,1,518.412,971.739Zm7.184-1.364a2.259,2.259,0,0,1-2.229-2.283V956.881a2.229,2.229,0,1,1,4.457,0v11.211A2.259,2.259,0,0,1,525.6,970.375Zm-14.368-2.859A2.259,2.259,0,0,1,509,965.232v-5.492a2.229,2.229,0,1,1,4.457,0v5.492A2.259,2.259,0,0,1,511.229,967.515Z",
    transform: "translate(-509 -925.663)",
    fill: "#945cff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31293_-_Outline",
    "data-name": "Path 31293 - Outline",
    d: "M518.412,995.646a2.242,2.242,0,0,1-2.229-2.249V932.8a2.229,2.229,0,1,1,4.457,0v60.6A2.241,2.241,0,0,1,518.412,995.646Zm-7.184-5.821A2.241,2.241,0,0,1,509,987.576V938.622a2.229,2.229,0,1,1,4.457,0v48.954A2.241,2.241,0,0,1,511.229,989.825Z",
    transform: "translate(-464.204 -926.275)",
    fill: "#945cff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31293_-_Outline-2",
    "data-name": "Path 31293 - Outline",
    d: "M511.229,1001.313A2.231,2.231,0,0,1,509,999.084v-70.11a2.229,2.229,0,1,1,4.457,0v70.11A2.231,2.231,0,0,1,511.229,1001.313Z",
    transform: "translate(-449.598 -926.745)",
    fill: "#945cff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18675",
    "data-name": "Group 18675",
    transform: "translate(617.193 976.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31292-2",
    "data-name": "Path 31292",
    d: "M547.024,966.184a1.085,1.085,0,0,0,1.105-1.064v-5.513a1.106,1.106,0,0,0-2.211,0v5.513A1.085,1.085,0,0,0,547.024,966.184Zm-8.289,3.175V955.367a1.106,1.106,0,0,1,2.211,0v13.992a1.106,1.106,0,0,1-2.211,0Zm-7.184-1.369V956.736a1.106,1.106,0,0,1,2.211,0V967.99a1.106,1.106,0,0,1-2.211,0Zm-7.184,6.312V950.424a1.106,1.106,0,0,1,2.21,0V974.3a1.106,1.106,0,0,1-2.21,0Zm-7.184,2.433V947.991a1.106,1.106,0,0,1,2.211,0v28.743a1.106,1.106,0,0,1-2.211,0ZM510,987.152V937.574a1.106,1.106,0,0,1,2.21,0v49.578a1.106,1.106,0,0,1-2.21,0Z",
    transform: "translate(-485.394 -925.539)",
    fill: "#945cff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31292_-_Outline-2",
    "data-name": "Path 31292 - Outline",
    d: "M511.228,989.464a2.259,2.259,0,0,0,2.229-2.283V937.792a2.229,2.229,0,1,0-4.457,0v49.388A2.259,2.259,0,0,0,511.228,989.464Zm7.184-10.378a2.259,2.259,0,0,0,2.229-2.283V948.169a2.229,2.229,0,1,0-4.457,0V976.8A2.259,2.259,0,0,0,518.412,979.086Zm7.184-2.423a2.259,2.259,0,0,0,2.229-2.283V950.594a2.229,2.229,0,1,0-4.457,0v23.786A2.259,2.259,0,0,0,525.6,976.662Zm14.367-4.923a2.259,2.259,0,0,0,2.229-2.283V955.517a2.229,2.229,0,1,0-4.457,0v13.938A2.259,2.259,0,0,0,539.964,971.739Zm-7.184-1.364a2.259,2.259,0,0,0,2.229-2.283V956.881a2.229,2.229,0,1,0-4.457,0v11.211A2.259,2.259,0,0,0,532.78,970.375Zm14.367-2.859a2.259,2.259,0,0,0,2.229-2.283v-5.492a2.229,2.229,0,1,0-4.457,0v5.492A2.259,2.259,0,0,0,547.147,967.515Z",
    transform: "translate(-485.518 -925.663)",
    fill: "#945cff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31293_-_Outline-3",
    "data-name": "Path 31293 - Outline",
    d: "M511.229,995.646a2.241,2.241,0,0,0,2.229-2.249V932.8a2.229,2.229,0,1,0-4.457,0v60.6A2.241,2.241,0,0,0,511.229,995.646Zm7.184-5.821a2.241,2.241,0,0,0,2.229-2.249V938.622a2.229,2.229,0,1,0-4.457,0v48.954A2.241,2.241,0,0,0,518.412,989.825Z",
    transform: "translate(-501.578 -926.275)",
    fill: "#945cff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31293_-_Outline-4",
    "data-name": "Path 31293 - Outline",
    d: "M511.229,1001.313a2.231,2.231,0,0,0,2.229-2.229v-70.11a2.229,2.229,0,1,0-4.457,0v70.11A2.231,2.231,0,0,0,511.229,1001.313Z",
    transform: "translate(-509 -926.745)",
    fill: "#945cff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 549.79, 969.78)",
    filter: "url(#Ellipse_866)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_866-2",
    "data-name": "Ellipse 866",
    cx: 20.822,
    cy: 20.822,
    r: 20.822,
    transform: "translate(44.81 22.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18670",
    "data-name": "Group 18670",
    transform: "translate(606.623 1000.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_172",
    "data-name": "Union 172",
    d: "M6.132,25.191a1.035,1.035,0,1,1,0-2.046H7.775v-2.4A8.811,8.811,0,0,1,0,12.013a1.16,1.16,0,1,1,2.32,0,6.477,6.477,0,0,0,12.954,0,1.16,1.16,0,1,1,2.32,0,8.809,8.809,0,0,1-7.773,8.736v2.4h1.645a1.035,1.035,0,1,1,0,2.046ZM3.686,11.866V5.2A5.163,5.163,0,0,1,8.8,0a5.163,5.163,0,0,1,5.109,5.2v6.669a5.164,5.164,0,0,1-5.109,5.2A5.164,5.164,0,0,1,3.686,11.866Z",
    transform: "translate(0 0)",
    fill: "#1b1c1d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnghamilabaudioad);
export default __webpack_public_path__ + "static/media/anghamilabaudioad.dde19174eb9b768a660737a3999349a7.svg";
export { ForwardRef as ReactComponent };